import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Avatar, Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import axios from 'axios';
import './style.scss';

let ticking = false;

export default class StickyProfile extends Component {
    state = {
        isOnline: false,
        lastScrollY: window.scrollY
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);

        const { username } = this.props.sellerCard.user;
        const isOnlineRoute = pathfinder('is_online', { username });

        axios.get(isOnlineRoute)
            .then(({ data }) => {
                this.setState({
                    isOnline: data.is_online === true
                });
            });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        if (!ticking && window.innerWidth < 959) {
            window.requestAnimationFrame(() => {
                this.setState({ lastScrollY: window.scrollY });
                ticking = false;
            });

            ticking = true;
        }
    }

    render() {
        const { sellerCard, contactClick, scrollPosition } = this.props;
        const { isOnline, lastScrollY } = this.state;

        const {
            has_live_gigs, is_on_vacation, allow_contact,
            contact_path, username, ratings_count,
            profile_photo, rating
        } = sellerCard.user;
        const showContact = has_live_gigs && (allow_contact || !is_on_vacation);
        const contactLink = contact_path || pathfinder('conversation', { id: username });
        const userRatingsCount = parseInt(ratings_count, 10);
        const stickyProfileClass = classnames('sticky-user-profile', { 'is-visible': lastScrollY > scrollPosition, 'is-online': isOnline });

        return (
            <div className={stickyProfileClass}>
                <div className="user-profile">
                    <Avatar src={profile_photo} username={username} size={44}/>

                    <div className="user-details">
                        <span className="username">{username}</span>
                        <div className="ratings-wrapper">
                            <span className="star-rating-s15" data-user-rating={rating} data-user-ratings-count={ratings_count}/>
                            <strong className="user-rating">{rating.toFixed(1)}</strong>
                            <span className="reviews">
                                <I18n k="user_page_perseus.seller_profile.num_reviews" params={{ count: userRatingsCount < 1000 ? userRatingsCount : '1k+' }}/>
                            </span>
                        </div>
                    </div>
                </div>

                {showContact &&
                    <Button href={contactLink}
                        onClick={contactClick}
                        ref={(ele) => { this.contactBtn = ele; }}
                        rel="nofollow"
                        data-user-id={username}
                        data-redirect-url={contactLink}
                        color="grey"
                        fill="ghost">
                        <I18n k="user_page_perseus.seller_profile.contact"/>
                    </Button>}
            </div>
        );
    }
}

StickyProfile.propTypes = {
    sellerCard: PropTypes.shape({
        user: PropTypes.object.isRequired
    }),
    contactClick: PropTypes.func,
    scrollPosition: PropTypes.number
};

StickyProfile.defaultProps = {
    contactClick: () => null,
    scrollPosition: 350
};
